
export default class OrderPaymentItem {
    id: string;
    orderId: string;
    paymentId: string;
    paymentDate: string;
    amount: string;
    response: string;
    notes: string;
    memo: string;
    paymentMethod: string;
    fullName: string;
    referenceNumber: string;
    refunded: string;
    voided: string;
    parentId: string;
    constructor(options) {
        this.id = options.id || "";
        this.orderId = options.orderId || "";
        this.paymentId = options.paymentId || "";
        this.paymentDate = options.paymentDate || "";
        this.amount = options.amount || "";
        this.response = options.response || "";
        this.notes = options.notes || "";
        this.memo = options.memo || "";
        this.paymentMethod = options.paymentMethod || "";
        this.fullName = options.fullName || "";
        this.referenceNumber = options.referenceNumber || "";
        this.refunded = options.refunded || "";
        this.voided = options.voided || "";
        this.parentId = options.parentId || "";
    }

}
